import React  from 'react';
import parse from 'html-react-parser';
import classnames from 'classnames';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

// Hooks

import { useLocation } from '../../../hooks/useLocation';

const NavBar = props => {

    const {
        houseIcon,
        menu
    } = props;

    const { currentLocation } = useLocation();

    const getSubMenus = subMenus => {
        return subMenus.map(subItem => {

            const {
                caption,
                disableMenu,
                reactLink,
                url,
                visibleMenu
            } = subItem;

            const disabledItemClass = classnames(
                { 'cursor-not-allowed pointer-events-all': disableMenu }
            );

            if(!visibleMenu) {
                return null;
            }

            if(reactLink) {
                return (
                    <Link
                        key = { caption }
                        to = { url }
                        id = { caption }
                        style = { { color: 'inherit' } }
                    >
                        <Dropdown.Item
                            as = 'span'
                            className = { disabledItemClass }
                        >
                            { caption }
                        </Dropdown.Item>
                    </Link>
                );
            }

            return (
                <Dropdown.Item
                    href = { url }
                    key = { caption }
                    disabled = { disableMenu }
                    className = { disabledItemClass }
                >
                    { parse(caption) }
                </Dropdown.Item>
            );
        });
    };

    const getMenu = () => {
        return menu.map(item => {
            const { caption, subMenus, url } = item;
            const areSubMenus = Array.isArray(subMenus) && subMenus.length > 0;

            const isDropdownButtonActive = subMenus.some(sm => sm.url === currentLocation);

            const variant = classnames(
                caption,
                { 'active': isDropdownButtonActive }
            );

            return areSubMenus
                ? (
                    <DropdownButton
                        title = { parse(caption) }
                        variant = { variant }
                        id = { `dropdown-variants-${ caption }` }
                        key = { caption }
                    >
                        { getSubMenus(subMenus) }
                    </DropdownButton>
                )
                : (
                    <a
                        className = 'navbar__simple-link'
                        href = { url }
                        key = { caption }
                    >
                        { parse(caption) }
                        { houseIcon && <FontAwesomeIcon icon='home'/> }
                    </a>
                );
        });
    };

    return(
        <div className = 'navbar'>
            <ButtonToolbar className = 'navbar__toolbar'>
                { getMenu() }
            </ButtonToolbar>
        </div>
    );
};

export default NavBar;